import './App.css';
import Form from './Components/Form/Forma';
import Regras from './Components/Regra/Regras';

function App() {
  return (
    <div className="App">
     <Form />
    </div>
  );
}

export default App;
